export function capitalize(val: string) {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1).toLowerCase();
}

export function joinWithConjunction(strings: string[], finalSeparator: string, separator = ', ') {
  const rest = [...strings];
  const finalString = rest.pop();

  if (!finalString) {
    return '';
  }

  if (rest.length === 0) {
    return finalString;
  }

  return `${rest.join(separator)} ${finalSeparator} ${finalString}`;
}
